export default __webpack_public_path__ + "static/media/ParceirosMotim.06560408.png";